module.exports = __webpack_public_path__ + "static/media/dsv.c489bbd7.mp4";